import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false, allowedEmails = [] }) => {
  const { user } = useAuth();
  const location = useLocation();

  // If not logged in, redirect to login with state
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  const email = String(user.email || "").toLowerCase();
  const allowList = (allowedEmails || []).map((e) => String(e).toLowerCase());
  const emailAllowed = allowList.includes(email);

  // ✅ If this route allows specific emails, let them through (even if not admin)
  if (emailAllowed) {
    return children;
  }

  // If adminOnly route but user is not admin
  if (adminOnly && user.role !== "admin") {
    alert("Access denied. Admins only.");
    return <Navigate to="/home" replace />;
  }

  // Otherwise, grant access
  return children;
};
